module.exports = __webpack_public_path__ + "img/64.d4d72ab8.png";